<template>
  <div>
    <div class="titlebar h-16 bg-gray-300 flex justify-between fixed top-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/home.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <span>@{{ AppState.me.user.username }}</span>
        <!-- <img class="ml-2" src="../ics/arrow-d.svg" alt=""> -->
      </div>
      <div class="flex justify-center items-center mr-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/close.svg" alt="">
      </div>
    </div>
    <div class="h-16"></div>

    <!-- <UserProfilePopBox v-if="showUserProfilePopBox"></UserProfilePopBox> -->

    <div class="max-w-xl mx-auto">
      <div class="p-8">
        <ComposerBox></ComposerBox>
      </div>
    </div>

    <LeftMenu></LeftMenu>

    <!-- <div class="h-16"></div>
    <div class="bottombar h-16 bg-gray-300 flex justify-between fixed bottom-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img src="../ics/plus.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <img src="../ics/bell.svg" alt="">
      </div>
      <div class="flex justify-center items-center mr-5">
        <img src="../ics/reload.svg" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
import { state as AppState } from '../../api/api'
export default {
  components: {
    LeftMenu: require('../uis/LeftMenu.vue').default,
    ComposerBox: require('../uis-composer/ComposerBox.vue').default
  },
  data () {
    return {
      AppState
    }
  }
}
</script>

<style>

</style>
